// src/components/PurchaseCreate.js
import React, { useState } from 'react';

const PurchaseCreate = ({ onAddPurchase, setCurrentPage }) => {
  const [formData, setFormData] = useState({
    invoiceNumber: '',
    date: '',
    supplier: '',
    items: []
  });

  const [currentItem, setCurrentItem] = useState({
    product: '',
    quantity: 1,
    price: 0
  });

  const calculateTotal = () => {
    return formData.items.reduce((sum, item) => sum + (item.quantity * item.price), 0);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCurrentItemChange = (e) => {
    const { name, value } = e.target;
    setCurrentItem(prev => ({
      ...prev,
      [name]: name === 'quantity' || name === 'price' ? Number(value) : value
    }));
  };

  const handleAddItem = () => {
    if (!currentItem.product || currentItem.quantity <= 0 || currentItem.price <= 0) {
      alert('لطفاً نام محصول، تعداد و قیمت معتبر وارد کنید');
      return;
    }

    const newItem = {
      id: Date.now(),
      product: currentItem.product,
      quantity: currentItem.quantity,
      unitPrice: currentItem.price,
      total: currentItem.quantity * currentItem.price
    };

    setFormData(prev => ({
      ...prev,
      items: [...prev.items, newItem]
    }));

    setCurrentItem({
      product: '',
      quantity: 1,
      price: 0
    });
  };

  const handleRemoveItem = (id) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.filter(item => item.id !== id)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (formData.items.length === 0) {
      alert('حداقل یک محصول به فاکتور اضافه کنید');
      return;
    }
    
    const newPurchase = {
      invoiceNumber: formData.invoiceNumber,
      date: formData.date,
      supplier: formData.supplier,
      totalAmount: calculateTotal(),
      items: formData.items
    };
    
    onAddPurchase(newPurchase);
    alert('فاکتور با موفقیت ثبت شد!');
    
    // رفتن به صفحه لیست فاکتورها
    setCurrentPage('purchaseList');
  };

  const formatPrice = (price) => {
    return price.toLocaleString('fa-IR');
  };

  return (
    <div className="purchase-create">
      <h2>ثبت فاکتور جدید</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>شماره فاکتور:</label>
          <input 
            name="invoiceNumber" 
            value={formData.invoiceNumber} 
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>تاریخ فاکتور:</label>
          <input 
            name="date" 
            value={formData.date} 
            onChange={handleChange}
            placeholder="۱۴۰۲/۱۱/۱۵"
            required
          />
        </div>
        
        <div className="form-group">
          <label>تامین کننده:</label>
          <input 
            name="supplier" 
            value={formData.supplier} 
            onChange={handleChange}
            required
          />
        </div>

        <div className="add-item-section">
          <h3>افزودن محصول</h3>
          <div className="item-inputs">
            <input 
              name="product"
              placeholder="نام محصول"
              value={currentItem.product}
              onChange={handleCurrentItemChange}
            />
            <input 
              name="quantity"
              type="number"
              placeholder="تعداد"
              value={currentItem.quantity}
              onChange={handleCurrentItemChange}
            />
            <input 
              name="price"
              type="number"
              placeholder="قیمت واحد"
              value={currentItem.price}
              onChange={handleCurrentItemChange}
            />
            <button type="button" onClick={handleAddItem}>
              ➕ افزودن
            </button>
          </div>
        </div>

        {formData.items.length > 0 && (
          <div className="items-table">
            <h3>لیست محصولات</h3>
            <table>
              <thead>
                <tr>
                  <th>محصول</th>
                  <th>تعداد</th>
                  <th>قیمت واحد</th>
                  <th>مجموع</th>
                  <th>عملیات</th>
                </tr>
              </thead>
              <tbody>
                {formData.items.map((item) => (
                  <tr key={item.id}>
                    <td>{item.product}</td>
                    <td>{item.quantity}</td>
                    <td>{formatPrice(item.unitPrice)}</td>
                    <td>{formatPrice(item.total)}</td>
                    <td>
                      <button type="button" onClick={() => handleRemoveItem(item.id)}>
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="3"><strong>مجموع کل:</strong></td>
                  <td><strong>{formatPrice(calculateTotal())} تومان</strong></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}

        <button type="submit" className="submit-btn">
          💾 ثبت فاکتور خرید
        </button>
      </form>
    </div>
  );
};

export default PurchaseCreate;